<div style="text-align: left; margin-bottom: 5px;" *ngIf="isDisplay">
  <em class="error-msg">
    {{ message }}
  </em>
</div>